var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState } from "react";
import { useData, HelpTooltip } from "ee-react-components";
import { OrganizationSiteRelationshipType, Permission, stringToPermission, } from "ee-nestjs-interfaces";
import { useAuth0 } from "@auth0/auth0-react";
var ModalState;
(function (ModalState) {
    ModalState[ModalState["EDIT"] = 0] = "EDIT";
    ModalState[ModalState["ADD"] = 1] = "ADD";
    ModalState[ModalState["HIDDEN"] = 2] = "HIDDEN";
    ModalState[ModalState["EDIT_OWNER"] = 3] = "EDIT_OWNER";
})(ModalState || (ModalState = {}));
var SiteOrganizations = function (_a) {
    var details = _a.details;
    var _b = useState(null), selectedOrganization = _b[0], setSelectedOrganization = _b[1];
    var _c = useState(ModalState.HIDDEN), modalState = _c[0], setModalState = _c[1];
    var _d = useState([]), selectedPermissions = _d[0], setSelectedPermissions = _d[1];
    var _e = useAuth0(), isAuthenticated = _e.isAuthenticated, isLoading = _e.isLoading, getAccessTokenSilently = _e.getAccessTokenSilently;
    // Fetch owner and stakeholder organizations
    var _f = useData("".concat(process.env.NOC_SVC_URL, "/sites/stakeholders/").concat(details.id), true), stakeholdersData = _f.data, isStakeholdersLoading = _f.isLoading, fetchStakeholders = _f.execute;
    var allPermissions = useData("".concat(process.env.NOC_SVC_URL, "/sites/all_site_permissions"), true).data;
    // Fetch all organizations
    var _g = useData("".concat(process.env.NOC_SVC_URL, "/organizations/listall"), !isLoading && isAuthenticated), allOrganizations = _g.data, isAllOrganizationsLoading = _g.isLoading;
    var handleRemoveStakeholder = function (organizationId, organizationName) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmed, accessToken, response, errorText, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    confirmed = window.confirm("Are you sure you want to remove access from \"".concat(organizationName, "\"?"));
                    if (!confirmed)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, , 8]);
                    return [4 /*yield*/, getAccessTokenSilently({
                            authorizationParams: {
                                audience: process.env.AUTH0_AUDIENCE,
                            },
                        })];
                case 2:
                    accessToken = _a.sent();
                    return [4 /*yield*/, fetch("".concat(process.env.NOC_SVC_URL, "/organizations/stakeholder_relationship/").concat(details.id, "/").concat(organizationId), {
                            method: "DELETE",
                            headers: {
                                "Content-Type": "application/json",
                                authorization: "Bearer ".concat(accessToken),
                            },
                        })];
                case 3:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 4];
                    void fetchStakeholders();
                    return [3 /*break*/, 6];
                case 4: return [4 /*yield*/, response.text()];
                case 5:
                    errorText = _a.sent();
                    alert("Failed to remove organization: ".concat(errorText));
                    _a.label = 6;
                case 6: return [3 /*break*/, 8];
                case 7:
                    error_1 = _a.sent();
                    alert("Failed to remove organization.");
                    return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var handleAddOrganization = function () { return __awaiter(void 0, void 0, void 0, function () {
        var confirmMsg, confirmed, accessToken, body, response, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!selectedOrganization) {
                        alert("Please select an organization.");
                        return [2 /*return*/];
                    }
                    confirmMsg = modalState === ModalState.EDIT
                        ? "Are you sure you want to make these edits?"
                        : "Are you sure you want to add a stakeholder?";
                    confirmed = window.confirm(confirmMsg);
                    if (!confirmed)
                        return [2 /*return*/];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, getAccessTokenSilently({
                            authorizationParams: {
                                audience: process.env.AUTH0_AUDIENCE,
                            },
                        })];
                case 2:
                    accessToken = _a.sent();
                    body = {
                        orgId: selectedOrganization,
                        siteId: details.id,
                        permissions: selectedPermissions,
                        relationshipType: OrganizationSiteRelationshipType.STAKEHOLDER,
                    };
                    return [4 /*yield*/, fetch("".concat(process.env.NOC_SVC_URL, "/organizations/stakeholder_relationship"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                authorization: "Bearer ".concat(accessToken),
                            },
                            body: JSON.stringify(body),
                        })];
                case 3:
                    response = _a.sent();
                    if (response.ok) {
                        setModalState(ModalState.HIDDEN);
                        void fetchStakeholders();
                    }
                    else {
                        alert("Request failed, contact software");
                        console.error("Error: ", response);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _a.sent();
                    alert("something went wrong: " + error_2);
                    console.error("Error:", error_2);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleChangeOwner = function () { return __awaiter(void 0, void 0, void 0, function () {
        var confirmMsg, confirmed, accessToken, body, response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    confirmMsg = "Are you sure you want to change the owner organization?";
                    confirmed = window.confirm(confirmMsg);
                    if (!confirmed)
                        return [2 /*return*/];
                    if (!selectedOrganization) {
                        alert("Please select an organization.");
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, getAccessTokenSilently({
                            authorizationParams: {
                                audience: process.env.AUTH0_AUDIENCE,
                            },
                        })];
                case 2:
                    accessToken = _a.sent();
                    body = {
                        orgId: selectedOrganization,
                        siteId: details.id,
                    };
                    return [4 /*yield*/, fetch("".concat(process.env.NOC_SVC_URL, "/organizations/change_owner"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                authorization: "Bearer ".concat(accessToken),
                            },
                            body: JSON.stringify(body),
                        })];
                case 3:
                    response = _a.sent();
                    if (response.ok) {
                        setModalState(ModalState.HIDDEN);
                        void fetchStakeholders();
                    }
                    else {
                        alert("Request failed: ".concat(response.statusText));
                        console.error("Error: ", response);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_3 = _a.sent();
                    alert("something went wrong: " + error_3);
                    console.error("Error:", error_3);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var permissionsCheckboxes = (allPermissions === null || allPermissions === void 0 ? void 0 : allPermissions.map(function (permission) { return ({
        id: permission.id,
        description: permission.description,
    }); })) || [];
    var handleSelectedPermissionChange = function (event) {
        var _a = event.target, value = _a.value, checked = _a.checked;
        var perm = stringToPermission(value);
        setSelectedPermissions(function (prevSelectedIds) {
            return checked
                ? __spreadArray(__spreadArray([], prevSelectedIds, true), [perm], false) : prevSelectedIds.filter(function (id) { return id !== value; });
        });
    };
    var handleNewRelationClick = function () {
        setSelectedOrganization(null);
        setSelectedPermissions([Permission.READ_GENERAL]);
        setModalState(ModalState.ADD);
    };
    var handleChangeOwnerClick = function () {
        var _a;
        setSelectedOrganization(((_a = stakeholdersData === null || stakeholdersData === void 0 ? void 0 : stakeholdersData.ownerOrganization) === null || _a === void 0 ? void 0 : _a.id) || null);
        setModalState(ModalState.EDIT_OWNER);
    };
    var modalStateToTitle = function (state) {
        switch (state) {
            case ModalState.EDIT:
                return "Edit permissions";
            case ModalState.ADD:
                return "Add organization to site";
            case ModalState.EDIT_OWNER:
                return "Change Owner Organization";
        }
    };
    var handleEditSiteClick = function (orgId, orgName) {
        var currentRelationship = stakeholdersData === null || stakeholdersData === void 0 ? void 0 : stakeholdersData.stakeholderOrganizations.find(function (org) { return org.orgId === orgId; });
        if (!currentRelationship) {
            // Should not happen.
            alert("No relationship found for ".concat(orgName));
            return;
        }
        setSelectedOrganization(orgId);
        setSelectedPermissions(currentRelationship.permissions);
        setModalState(ModalState.EDIT);
    };
    return (React.createElement("div", { className: "p-4" },
        isStakeholdersLoading ? (React.createElement("p", null, "Loading...")) : (React.createElement(React.Fragment, null,
            (stakeholdersData === null || stakeholdersData === void 0 ? void 0 : stakeholdersData.ownerOrganization) && (React.createElement("div", { className: "mb-4" },
                React.createElement("h4", { className: "font-semibold" }, "Owner Organization"),
                React.createElement("div", { className: "flex items-center space-x-6" },
                    React.createElement("p", null, stakeholdersData.ownerOrganization.name),
                    React.createElement("button", { onClick: handleChangeOwnerClick }, "Change")))),
            React.createElement("div", { className: "mb-4" },
                React.createElement("h4", { className: "font-semibold" }, "Shared with"),
                React.createElement("table", { className: "space-y-2" },
                    React.createElement("tbody", null, stakeholdersData === null || stakeholdersData === void 0 ? void 0 : stakeholdersData.stakeholderOrganizations.map(function (organization) { return (React.createElement("tr", { key: organization.orgId, className: "flex items-center justify-between text-bold" },
                        React.createElement("td", null, organization.orgName),
                        React.createElement("td", { className: "pl-10" },
                            React.createElement("button", { onClick: function () {
                                    return handleEditSiteClick(organization.orgId, organization.orgName);
                                }, hidden: organization.isNoc, className: "text-white hover:text-white gap-x-2 items-center" }, "Edit")),
                        React.createElement("td", { className: "pl-4" },
                            React.createElement("button", { onClick: function () {
                                    return handleRemoveStakeholder(organization.orgId, organization.orgName);
                                }, hidden: organization.isNoc, className: "text-red hover:text-white gap-x-2 items-center" }, "Remove")))); })))))),
        React.createElement("button", { className: "bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600", onClick: handleNewRelationClick }, "Add Stakeholder"),
        modalState != ModalState.HIDDEN && (React.createElement("div", { className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center" },
            React.createElement("div", { className: "bg-black text-white p-6 rounded shadow-lg w-96" },
                React.createElement("h3", { className: "text-sm font-semibold mb-4" }, modalStateToTitle(modalState)),
                React.createElement("select", { className: "w-full border border-gray-300 rounded p-2 mb-4 bg-gray-800 text-white", onChange: function (e) { return setSelectedOrganization(Number(e.target.value)); }, value: selectedOrganization || "", disabled: modalState === ModalState.EDIT },
                    React.createElement("option", { value: "", disabled: true }, "Select an organization"), allOrganizations === null || allOrganizations === void 0 ? void 0 :
                    allOrganizations.map(function (org) { return (React.createElement("option", { key: org.id, value: org.id }, org.name)); })),
                modalState != ModalState.EDIT_OWNER && (React.createElement("div", null,
                    React.createElement("h4", { className: "font-semibold mb-2" }, "Permissions"),
                    React.createElement("ul", { className: "list-disc pl-5" }, permissionsCheckboxes.map(function (permission) { return (React.createElement("label", { className: "flex items-center space-x-2" },
                        React.createElement("input", { type: "checkbox", value: permission.id, checked: selectedPermissions.includes(permission.id), disabled: permission.id === Permission.READ_GENERAL, onChange: handleSelectedPermissionChange }),
                        React.createElement("span", null, permission.id),
                        React.createElement(HelpTooltip, { text: permission.description }))); })))),
                React.createElement("div", { className: "flex justify-end space-x-2" },
                    React.createElement("button", { className: "bg-gray-300 px-4 py-2 rounded hover:bg-gray-400", onClick: function () { return setModalState(ModalState.HIDDEN); } }, "Cancel"),
                    React.createElement("button", { className: "bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600", onClick: modalState === ModalState.EDIT_OWNER
                            ? handleChangeOwner
                            : handleAddOrganization, disabled: isAllOrganizationsLoading }, modalState === ModalState.EDIT ||
                        modalState == ModalState.EDIT_OWNER
                        ? "Save"
                        : "Add")))))));
};
export default SiteOrganizations;
